import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Home } from "lucide-react";
import { api } from "../lib/api";

export function PaymentSuccessPage() {
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id");
  const [status, setStatus] = useState("polling");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") { setStatus("paid"); return; }
      } catch {/* ignore */}
      if (attempts < 10) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 grain">
      <div className="glass-strong rounded-3xl p-10 max-w-md w-full text-center space-y-4">
        {status === "polling" && (<>
          <Loader2 className="w-12 h-12 text-blue-300 mx-auto animate-spin" />
          <h1 className="font-heading text-2xl text-white">Confirming payment…</h1>
          <p className="text-slate-400 text-sm">Hang tight, this usually takes a few seconds.</p>
        </>)}
        {status === "paid" && (<>
          <CheckCircle2 className="w-14 h-14 text-emerald-400 mx-auto" />
          <h1 className="font-heading text-3xl text-white">Payment received</h1>
          <p className="text-slate-400 text-sm">Thanks — the invoice has been marked paid.</p>
          <Link to="/" className="inline-flex items-center gap-2 bg-white text-black px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-slate-100">
            <Home className="w-4 h-4" /> Back to dashboard
          </Link>
        </>)}
        {(status === "timeout" || status === "error") && (<>
          <XCircle className="w-12 h-12 text-amber-400 mx-auto" />
          <h1 className="font-heading text-2xl text-white">Still processing</h1>
          <p className="text-slate-400 text-sm">If your bank confirms, the invoice will update shortly.</p>
          <Link to="/" className="inline-flex items-center gap-2 bg-white text-black px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-slate-100">
            <Home className="w-4 h-4" /> Back to dashboard
          </Link>
        </>)}
      </div>
    </div>
  );
}

export function PaymentCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-4 grain">
      <div className="glass-strong rounded-3xl p-10 max-w-md w-full text-center space-y-4">
        <XCircle className="w-12 h-12 text-amber-400 mx-auto" />
        <h1 className="font-heading text-2xl text-white">Payment cancelled</h1>
        <p className="text-slate-400 text-sm">No worries — the invoice is still open. You can pay later from the same link.</p>
        <Link to="/" className="inline-flex items-center gap-2 bg-white text-black px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-slate-100">
          <Home className="w-4 h-4" /> Back to dashboard
        </Link>
      </div>
    </div>
  );
}
